const $ = window.jQuery

$(() => {
  $('.hoverbox-trigger').tooltip({
    classes: {
      'ui-tooltip': 'hoverbox'
    }
  })
})
